import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStep } from "../../new-booking-form.slice";
import TAConditionProvidentLandProjects from "./TAConditionProvidentLandProjects";
import TAConditionPuravankaraLandProjects from "./TAConditionPuravankaraLandProjects";
import TermsAndConditionFirst from "./TermsAndConditionFirst";
import { route } from "../../../../services/apiRoutes";
import { GET } from "../../../../services/axiosInstance";
import Loader from "../../../../components/Loader";

const TermsAndCondition = ({ isPreview }) => {
  const [termsAndCondition, setTermsAndCondition] = useState(null);
  const { activeStep, isLoading, enquiryDetails } = useSelector(
    (state) => state?.newBookingForm
  );

  const dispatch = useDispatch();
  
  useEffect(() => {
    if(enquiryDetails?.data?.ProjectName && enquiryDetails?.data?.projectBrandName) {
      getTermsAndCondition();
    }
    
  }, [enquiryDetails]);

  const getTermsAndCondition = async () => {
    try {
      const res = await GET(
        route.GET_TERMS_AND_CONDITION,
        `/${enquiryDetails?.data?.ProjectName}/${enquiryDetails?.data?.projectBrandName}`
      );
      let data = {};
      if (res?.response?.success) {
        data = res?.response?.response?.data || {};
        setTermsAndCondition(data);
      } else {
        
      }
    } catch (error) {
      setTermsAndCondition(null);
      console.log("error", error);
    }
  };

  const handlePrevious = () => {
    dispatch(setActiveStep(activeStep - 1));
  };

  const showTermsCondtionComp = () => {
    if (
      termsAndCondition &&
      termsAndCondition?.termsConditions === "puravankara_terms"
    ) {
      return (
        <TermsAndConditionFirst
          isPreview={isPreview}
          handlePrevious={handlePrevious}
          primarySource={enquiryDetails?.data?.primarySource !== null && enquiryDetails?.data?.primarySource?.length > 0 ? enquiryDetails?.data?.primarySource : null}
        />
      );
    } else if (
      termsAndCondition &&
      termsAndCondition?.termsConditions === "puravankara_land_terms"
    ) {
      return (
        <TAConditionPuravankaraLandProjects
          isPreview={isPreview}
          handlePrevious={handlePrevious}
          primarySource={enquiryDetails?.data?.primarySource !== null && enquiryDetails?.data?.primarySource?.length > 0 ? enquiryDetails?.data?.primarySource : null}
          projectName={enquiryDetails?.data?.ProjectName}
          />
        );
      } else if (
        termsAndCondition &&
        (termsAndCondition?.termsConditions === "provident_land_terms" ||
          termsAndCondition?.termsConditions === "provident_terms")
      ) {
        return (
          <TAConditionProvidentLandProjects
          isPreview={isPreview}
          handlePrevious={handlePrevious}
          primarySource={enquiryDetails?.data?.primarySource !== null && enquiryDetails?.data?.primarySource?.length > 0 ? enquiryDetails?.data?.primarySource : null}
          projectName={enquiryDetails?.data?.ProjectName}
        />
      );
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      {termsAndCondition && showTermsCondtionComp()}
    </>
  );
};

export default TermsAndCondition;
